// Tela de "saiu versão nova". Aparece no lugar do error boundary quando o erro
// é só um chunk antigo que sumiu depois de um deploy (ver lib/deployDetector).
// Recarrega sozinha em 5 segundos; o botão é para quem não quer esperar.

import { useEffect, useState } from 'react'
import { RefreshCw } from 'lucide-react'
import styles from './NewVersionScreen.module.css'

const RELOAD_AFTER_MS = 5000

export function NewVersionScreen() {
  const [seconds, setSeconds] = useState(RELOAD_AFTER_MS / 1000)

  useEffect(() => {
    const tick = setInterval(() => setSeconds((s) => Math.max(0, s - 1)), 1000)
    const timer = setTimeout(() => {
      // `true` força buscar o documento de novo em vez do cache.
      window.location.reload()
    }, RELOAD_AFTER_MS)
    return () => {
      clearInterval(tick)
      clearTimeout(timer)
    }
  }, [])

  return (
    <div className={styles.screen} role="status" aria-live="polite">
      <span className={styles.badge}>
        <RefreshCw size={32} className={styles.spin} aria-hidden="true" />
      </span>
      <h1 className={styles.title}>Uma versão nova acabou de sair</h1>
      <p className={styles.text}>
        Estamos atualizando a sua tela para a versão mais recente. Leva {seconds}{' '}
        {seconds === 1 ? 'segundo' : 'segundos'}.
      </p>
      <div className={styles.bar} aria-hidden="true">
        <div className={styles.fill} />
      </div>
      <button
        type="button"
        className={styles.action}
        onClick={() => window.location.reload()}
      >
        Atualizar agora
      </button>
    </div>
  )
}
